enum PfmTransactionDisplayTransactionType {
  MORSOM_SPARING = 'MORSOM_SPARING',
  DEBIT_CARD = 'DEBIT_CARD',
  VISA_CARD = 'VISA_CARD',
  CREDIT_CARD = 'CREDIT_CARD',
  UBETJENT = 'UBETJENT',
  ATM = 'ATM',
  LOAN = 'LOAN',
  INCOME = 'INCOME',
  INT_PAY = 'INT_PAY',
  DOM_PAY = 'DOM_PAY',
  EFAKTURA = 'EFAKTURA',
  TRANSFER = 'TRANSFER',
  VIPPS = 'VIPPS',
  OTHER = 'OTHER',
}

export default PfmTransactionDisplayTransactionType;
